import { uniq } from 'lodash-es';
import type { Field } from '@/hooks/useFields';

// Include nested avatar.id so list views can render avatars instead of raw IDs
const USER_SUBFIELDS = ['id', 'avatar.id', 'email', 'first_name', 'last_name'] as const;

function isUserSpecial(field: Field): boolean {
    const specials = field.meta?.special || [];
    return specials.includes('user-created') || specials.includes('user-updated');
}

/**
 * Expand selected field names to include user subfields (dot-notation) for user-created/user-updated.
 */
export function expandUserFields(selected: string[], fields: Field[]): string[] {
    if (!fields.length) return selected;

    const fieldMap = new Map(fields.map((f) => [f.field, f] as const));
    const expanded: string[] = [];

    for (const name of selected) {
        expanded.push(name);
        const field = fieldMap.get(name);
        if (field && isUserSpecial(field)) {
            for (const sub of USER_SUBFIELDS) {
                expanded.push(`${name}.${sub}`);
            }
        }
    }

    return uniq(expanded);
}
